import React from "react";
import { Link } from "react-scroll";

const Prices = () => {
  return (
    <div id="prices" className="flex justify-center text-white pt-4 pb-4 ">
      <div className="bg-[#2f1847] w-full max-w-screen-lg px-3 pb-2">
        <div className="pb-2">
          <h1 className="text-[#FF0080] text-4xl py-5">Prices</h1>
          <p>
            Have a look at the price list below and if you can't find a service
            or need one adapted to you, please{" "}
            <Link
              to="contact"
              hashSpy={true}
              spy={true}
              smooth={true}
              offset={-100}
              duration={800}
            >
              <span className="text-[#FF0080] cursor-pointer">get in touch</span>
            </Link>{" "}
            for a personalised quote.
          </p>
        </div>
        <div className="grid pt-4">
          <table className="table-auto mb-3">
            <thead>
              <tr className="text-lg">
                <th className="text-left">Service</th>
                <th className="text-right">Price</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b-[1px] border-[#ffffff]">
                <td className="text-left">Casual make-Up</td>
                <td className="text-right text-[#FF0080]">&euro;35</td>
              </tr>
              <tr className="border-b-[1px] border-[#ffffff] ">
                <td className="text-left">Bridal make-Up</td>
                <td className="text-right text-[#FF0080]">&euro;50</td>
              </tr>
              <tr className="border-b-[1px] border-[#ffffff] ">
                <td className="text-left">Special effects make-Up</td>
                <td className="text-right text-[#FF0080]">&euro;40</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Prices;
